import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from "../firebase/firebase";

export default function Signup() {

    const navigate = useNavigate();

    async function signup(formData) {
        await createUserWithEmailAndPassword(auth, formData.get("email"), formData.get("password"))
            .then(userCredential => {
                // Signed in
                const user = userCredential.user;
                updateProfile(user, { displayName: formData.get("name") });
                window.alert("Dein Konto wurde erfolgreich angelegt.");
                navigate("/post")
            })
            .catch(error => {
                console.log(error.message)
            })
    }

    return (
        <div className="page-class">
            <h1>Registrieren</h1>
            <form action={signup}>
                <div className="mb-3">
                    <label htmlFor="name" className="form-label">Vorname</label>
                    <input type="text" required name="name" className="form-control" />
                </div>
                <div className="mb-3">
                    <label htmlFor="email" className="form-label">E-Mail-Adresse</label>
                    <input type="email" required name="email" className="form-control" />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Passwort</label>
                    <input type="password" required name="password" className="form-control" />
                </div>
                <button type="submit" className="btn btn-primary">Registrieren</button>
            </form>
        </div>
    )
}